import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://sreqhqpqushlxbpvmzgf.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNyZXFocXBxdXNobHhicHZtemdmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY2MTM1NTUsImV4cCI6MjA2MjE4OTU1NX0.MoIU-3S0ErhPSBZK98SWVisRRw6BXT8PjDYSQsVEz6w';

export const supabase = createClient(supabaseUrl, supabaseAnonKey); 